/* eslint-disable */
// @ts-nocheck
export function initHeroSampleBreakdown() {
  var PROFILES = {
    assembly: { Materials: 66.6, Labor: 15.3, Overhead: 9.3, 'Value Add': 8.8 },
    material: { Materials: 84, Labor: 8, Overhead: 5, 'Value Add': 3 },
  }
  var COLORS = {
    Materials: '#f59e0b',
    Labor: '#fbbf24',
    Overhead: '#fcd34d',
    'Value Add': '#fde68a',
  }
  var ORDER = ['Materials', 'Labor', 'Overhead', 'Value Add']
  var card = document.getElementById('mi-bd')
  if (!card) return

  var GAP = 10

  function money(v) {
    if (!v) return '0'
    return window.formatQuantity(v)
  }
  function render(node) {
    var pct = (node.cost / (node.rootCost || node.cost)) * 100
    var head = (pct >= 99.95 ? '100.0' : pct.toFixed(1)) + '% of product total'
    var rows = ORDER.map(function (k) {
      var v
      if (node.breakdown) {
        v = node.breakdown[k]
        if (v == null || v <= 0) return ''
      } else {
        var prof = PROFILES[node.profile] || PROFILES.material
        v = (node.cost * prof[k]) / 100
        if (!v || v <= 0) return ''
      }
      return (
        '<div class="mi-bd__row"><span class="mi-bd__dot" style="background:' +
        COLORS[k] +
        '"></span>' +
        '<span class="mi-bd__name">' +
        k +
        '</span><span class="mi-bd__amt">$' +
        money(v) +
        ' <i>USD</i></span></div>'
      )
    }).join('')
    card.innerHTML =
      '<div class="mi-bd__head"><span>' +
      head +
      '</span>' +
      '<button type="button" class="mi-bd__close" aria-label="Close breakdown">' +
      CLOSE_SVG +
      '</button></div>' +
      rows
  }
  function positionAt(anchor) {
    var r = anchor.getBoundingClientRect()
    var w = card.offsetWidth || 234,
      h = card.offsetHeight || 150
    // Stay inside the fake browser window: a card that hangs past its frame
    // reads as a page-level popup rather than part of the model.
    var host = document.getElementById('cm2-inline-browser')
    var b = host
      ? host.getBoundingClientRect()
      : {
          left: 0,
          top: 0,
          right: window.innerWidth,
          bottom: window.innerHeight,
        }
    var PAD = 8

    // Below the cell, right-aligned to it, so the card never sits beside the
    // number it explains and never covers the column it came from.
    var top = r.bottom + GAP
    if (top + h > b.bottom - PAD) top = r.top - h - GAP
    if (top < b.top + PAD) top = b.top + PAD

    var left = r.right - w
    if (left + w > b.right - PAD) left = b.right - PAD - w
    if (left < b.left + PAD) left = b.left + PAD

    card.style.left = left + 'px'
    card.style.top = top + 'px'
  }

  function isMobile() {
    return window.matchMedia('(max-width: 600px)').matches
  }
  var openTrigger = null // mobile: the trigger whose card is currently open
  function show(node, anchor) {
    render(node)
    card.classList.add('is-open')
    positionAt(anchor)
  }
  function hide() {
    card.classList.remove('is-open')
    if (openTrigger) {
      openTrigger.classList.remove('is-active')
      openTrigger = null
    }
  }
  function nodeFor(row) {
    return (window.MI_NODES || {})[row.getAttribute('data-i')]
  }

  var CLOSE_SVG =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M4.5 4.5L11.5 11.5M11.5 4.5L4.5 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>'

  // The card is rebuilt on every open, so bind the close button once by
  // delegation rather than re-wiring it each render.
  card.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.mi-bd__close')) return
    e.stopPropagation()
    e.preventDefault()
    hide()
  })

  // The cost cell IS the trigger: hovering the number or its bar is what a reader
  // does when asking "what makes up this cost", so there is no separate icon.
  document.querySelectorAll('.mi-bom--table').forEach(function (table) {
    table.querySelectorAll('.mi-row[data-i]').forEach(function (row) {
      if (!nodeFor(row)) return
      var cell = row.querySelectorAll('.mi-row__val')[1]
      if (!cell || cell.classList.contains('mi-bd-cell')) return
      cell.classList.add('mi-bd-cell')

      // On mobile (no hover) a tap toggles the bottom-sheet card. Stop it from
      // bubbling to the row's expand toggle.
      cell.addEventListener('click', function (e) {
        if (!isMobile()) return
        e.stopPropagation()
        e.preventDefault()
        var node = nodeFor(row)
        if (!node) return
        if (openTrigger === cell) {
          hide()
        } else {
          if (openTrigger) openTrigger.classList.remove('is-active')
          openTrigger = cell
          cell.classList.add('is-active')
          show(node, cell)
        }
      })
      cell.addEventListener('mouseenter', function () {
        if (isMobile()) return
        var node = nodeFor(row)
        if (node) show(node, cell)
      })
      cell.addEventListener('mouseleave', function () {
        if (isMobile()) return
        hide()
      })
    })
  })

  // Mobile: dismiss the sheet on an outside tap or Escape.
  document.addEventListener(
    'click',
    function (e) {
      if (!isMobile() || !card.classList.contains('is-open')) return
      if (
        e.target &&
        e.target.closest &&
        (e.target.closest('.mi-bd-cell') || e.target.closest('#mi-bd'))
      )
        return
      hide()
    },
    true,
  )
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && card.classList.contains('is-open')) hide()
  })

  // Any scroll dismisses the anchored card (it would otherwise drift).
  window.addEventListener('scroll', hide, true)
  window.addEventListener('resize', hide)
}
